import React, { lazy, Suspense } from "react";
import "./index.css";
import { Router } from "@reach/router";
import { NotFoundPage } from "./pages/error";
import LinearLoader from "./components/linear_loader.component";
import "react-loading-skeleton/dist/skeleton.css";

const ContainerPage = lazy(() => import("./pages/container.page"));
const DetailsPage = lazy(() => import("./pages/details.page"));
const TariffPage = lazy(() => import("./pages/tariff.page"));
const SuccessPage = lazy(() => import("./pages/success.page"));
const CancelPage = lazy(() => import("./pages/cancel.page"));

class App extends React.Component {
  render() {
    return (
      <Suspense fallback={<LinearLoader />}>
        <Router>
          <NotFoundPage default />

          <ContainerPage path="con/:evseID">
            <NotFoundPage default />

            <DetailsPage path="*/" />
            <TariffPage path="tariff/" />
            {/*<SuccessPage path="success/"/>*/}
            <SuccessPage path="success/session/:sessionID" />
            <CancelPage path="canceled" />
          </ContainerPage>
        </Router>
      </Suspense>
    );
  }
}

export default App;
